var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2478 13.2108C1.55491 13.7031 2.08786 14.0012 2.67051 14.0012H13.3295C13.9121 14.0012 14.4451 13.7031 14.7522 13.2108C15.0548 12.714 15.0819 12.1043 14.8245 11.5849L9.49045 0.921357C9.2059 0.356796 8.63682 0 8 0C7.36318 0 6.7941 0.356796 6.50955 0.921361L1.17554 11.5849C0.918099 12.1088 0.945193 12.714 1.2478 13.2108ZM8.67748 4.49844V8.80269C8.67748 9.17757 8.37488 9.48017 8 9.48017C7.62512 9.48017 7.32252 9.17757 7.32252 8.80269V4.49844C7.32252 4.12358 7.62512 3.82096 8 3.82096C8.37488 3.82096 8.67748 4.12358 8.67748 4.49844ZM7.32252 11.2732V10.7809C7.32252 10.4061 7.62512 10.1035 8 10.1035C8.37488 10.1035 8.67748 10.4061 8.67748 10.7809V11.2732C8.67748 11.6436 8.37488 11.9507 8 11.9507C7.62512 11.9507 7.32252 11.6436 7.32252 11.2732Z",
    fill: "#FB2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerRed);
export default __webpack_public_path__ + "static/media/dangerRed.e5d074c18cef7e9904d7228fa73ddecc.svg";
export { ForwardRef as ReactComponent };